"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var SvgIcon_1 = __importDefault(require("@material-ui/core/es/SvgIcon/SvgIcon"));
var ElementalistIcon = /** @class */ (function (_super) {
    __extends(ElementalistIcon, _super);
    function ElementalistIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ElementalistIcon.prototype.render = function () {
        return (react_1.default.createElement(SvgIcon_1.default, null,
            react_1.default.createElement("svg", null,
                react_1.default.createElement("path", { d: "m 9.4520646,16.720772 C 8.3049981,14.856809 5.0896221,9.1875417 5.1469881,9.1301747 c 0.03208,-0.03208 2.136058,-0.04207 4.6755055,-0.02219 l 4.6171764,0.03613 -1.688447,2.9483833 c -2.34894,4.101742 -2.8548704,4.936828 -2.9909344,4.936828 -0.06509,0 -0.20379,-0.138848 -0.308224,-0.308552 z M 2.4536171,4.6020445 C 1.2564821,2.5206075 0.24649102,0.70091614 0.20919302,0.55828814 c -0.06552,-0.250559 0.08856,-0.259325 4.55816708,-0.259325 4.462057,0 4.6235895,0.0091 4.5584795,0.258129 -0.03713,0.141971 -0.9499245,1.79272336 -2.0284405,3.66833736 -1.078515,1.875615 -2.058129,3.579521 -2.176921,3.78646 -0.118791,0.206938 -0.277695,0.3758772 -0.353118,0.3754192 -0.07542,-4.58e-4 -1.116608,-1.7038272 -2.313743,-3.7852642 z m 9.9589709,-0.101591 c -1.225636,-2.136624 -2.22843,-3.95603236 -2.22843,-4.04313036 0,-0.116573 1.21225,-0.15836 4.593993,-0.15836 3.607278,0 4.593994,0.03717 4.593994,0.173078 0,0.163027 -0.815049,1.62335736 -3.366155,6.03116936 -0.599888,1.036487 -1.152415,1.8839572 -1.227839,1.8832672 -0.07542,-6.85e-4 -1.139927,-1.7494012 -2.365563,-3.8860242 z m -5.7566789,3.238035 c 0.449881,-0.866075 3.0399105,-5.24538 3.1022475,-5.24538 0.09403,0 3.0315504,5.083958 3.0315504,5.246687 0,0.05585 -1.392125,0.101543 -3.0936114,0.101543 -1.7014865,0 -3.0695705,-0.04628 -3.0401865,-0.10285 z" }))));
    };
    return ElementalistIcon;
}(react_1.Component));
exports.default = ElementalistIcon;



//////////////////
// WEBPACK FOOTER
// ./src/components/icons/ElementalistIcon.tsx
// module id = 789
// module chunks = 0